(function($) {

	/*
	$(window).scroll(function() {

		if($(window).scrollTop() >= 100) $(".c-header__center").addClass("hide");
		if($(window).scrollTop() <= 100) $(".c-header__center").removeClass("hide");


	});

*/
	var timer = 0;
	var aLine = [];
	
	function doAction() {
		
		if (!aLine.length) return;
		
		last = aLine[0];
		var upCounter = 0;
		var downCounter = 0;
		for (var i = 1; i < aLine.length; i++) {
			if (last > aLine[i]) {
				upCounter++;
			}
			else {
				downCounter++;
			}
			last = aLine[i];
		}
		
		if (upCounter && downCounter) return;
		
		if (downCounter){
			$(".c-header__center").addClass("hide");
		} 
		else {
			$(".c-header__center").removeClass("hide");
		}
	};

	$(window).scroll(function(event){	
		if (timer) {
			return;
		}
		
		var st = Math.floor($(this).scrollTop());
		aLine.splice(0, aLine.length-4);
		aLine.push(st);
		
		timer = window.setTimeout(function () {
			timer = 0;
			doAction();
		}, 1000/60);
		
	});


})(jQuery);

